<mat-nav-list>
  <h2 class="mat-h2">{{data.name}}</h2>
  @if (data.phone1) {
    <mat-list-item>
      <mat-icon>phone</mat-icon>
      <a mat-list-item href="{{phone1}}" (click)="logPhone(data.phone1)">{{data.phone1}}</a>
    </mat-list-item>
  }

  @if (data.phone2) {
    <mat-list-item>
      <mat-icon>phone</mat-icon>
      <a mat-list-item href="{{phone2}}" (click)="logPhone(data.phone2)">{{data.phone2}}</a>
    </mat-list-item>
  }

  @if (data.email) {
    <mat-list-item>
      <mat-icon>email</mat-icon>
      <a mat-list-item href="{{email}}" (click)="logMail(data.email)">{{data.email}}</a>
    </mat-list-item>
  }
</mat-nav-list>